import { NotFoundState } from "@rio-cloud/rio-uikit";
import { useMediaQuery } from "@mui/material";
import { useIntl } from "react-intl";

const EmptySelection = () => {
    const intl = useIntl();
    const isMobile = useMediaQuery("(max-width: 768px)");

    if (isMobile) {
        return (
            <div className="w-full flex justify-center items-center p-4">
                <NotFoundState
                    icon="rioglyph-truck"
                    headline={intl.formatMessage({ id: "intl-msg:monitoring.noSelection.headline" })}
                    message={intl.formatMessage({ id: "intl-msg:monitoring.noSelection.message" })}
                    outerClassName="border-none w-full"
                />
            </div>
        );
    }

    return (
        <table className="margin-top-10 w-full">
            <tbody>
                <tr>
                    <td colSpan={5}>
                        <NotFoundState
                            icon="rioglyph-truck"
                            headline={intl.formatMessage({ id: "intl-msg:monitoring.noSelection.headline" })}
                            message={intl.formatMessage({ id: "intl-msg:monitoring.noSelection.message" })}
                            outerClassName="border-none"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default EmptySelection;
